import './styles.scss'

import React from 'react'
import { kea, useValues } from 'kea'
import PropTypes from 'prop-types'

import I18n from 'lib/i18n'
import Imgix from 'lib/tags/imgix'

import railsContext from 'lib/selectors/rails-context'

import Translate from './translate'

const logic = kea({
  connect: {
    props: [railsContext, ['dpr']]
  }
})

export default function Reviews ({ loadMore, isLoading, reviews, isTeacher, translateReview, translating }) {
  const { dpr } = useValues(logic())

  const reviewsToShow = reviews.reviews
  const reviewCount = reviews.count

  return (
    <div id='reviews'>
      <div className='widget nospace2'>
        <div className='coursebox'>
          <h1 className='course_title'>
            {I18n.t('profiles.show_reviews.reviews')} <small>({reviewCount})</small>
          </h1>
        </div>
        <div className='undercoursebox'>
          {reviews.count > 0
            ? reviewsToShow.map(review => (
                <div key={review.id} className='clearfix mb-30'>
                  <div className='reviewer-photo'>
                    <a href={review.url}>
                      <Imgix src={review.avatar} width={100} height={100} alt={review.avatarAlt} dpr={dpr} />
                      <br />
                      <small>{review.name}</small>
                    </a>
                  </div>
                  <div className='review'>
                    {review.edit_url ? <a className='icon1 write edit-icon' href={review.editUrl} /> : null}
                    <div className='rate-stars mb-10'>
                      <div className={`rate-${review.stars}`} />
                    </div>
                    <div className='review-content'>{review.review}</div>
                    <Translate review={review} translateReview={translateReview} translating={translating} />
                  </div>
                </div>
              ))
            : isTeacher
            ? I18n.t('profiles.show_reviews.no_reviews')
            : I18n.t('profiles.show_reviews.no_reviews_for_student')}
          {reviewCount > 5 && reviewsToShow && reviewsToShow.length <= 5 ? (
            <div className='float-right mt--20'>
              <span
                style={{ color: '#888', fontSize: 22, cursor: isLoading ? 'wait' : 'pointer' }}
                onClick={() => loadMore()}
              >
                ...
              </span>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  )
}

Reviews.propTypes = {
  isTeacher: PropTypes.bool,
  reviews: PropTypes.object,
  translateReview: PropTypes.func,
  translating: PropTypes.bool,
  loadMore: PropTypes.func,
  isLoading: PropTypes.bool
}

// TODO: link to edit review
